import React from 'react';
import { CardId } from './types';
import { TotalEntitiesCard } from './TotalEntitiesCard';
import { TotalReturnsCard } from './TotalReturnsCard';
import { NotStartedCard } from './NotStartedCard';
import { PendingTasksCard } from './PendingTasksCard';
import { AwaitingReviewCard } from './AwaitingReviewCard';
import { SubmittedThisMonthCard } from './SubmittedThisMonthCard';
import { TasksByStatusCard } from './TasksByStatusCard';
import { ReturnsByDueDateCard } from './ReturnsByDueDateCard';
import { TypesOfReturnsCard } from './TypesOfReturnsCard';
import { YourRoleInReturnsCard } from './YourRoleInReturnsCard';
import { VatNumberCheckerCard } from './VatNumberCheckerCard';
import { TeamAllocationCard } from './TeamAllocationCard';
import { CalendarCard } from './CalendarCard';
import { SubmittedReturnsChartCard } from './SubmittedReturnsChartCard';
import { TimeToSubmitCard } from './TimeToSubmitCard';
import { CaptureStatCard } from './CaptureStatCard';
import { CAPTURE_STAT_CARD_IDS } from './capture-stat-card-config';
import {
  TotalEntitiesCardProps,
  TotalReturnsCardProps,
  NotStartedCardProps,
  PendingTasksCardProps,
  AwaitingReviewCardProps,
  SubmittedThisMonthCardProps,
  TasksByStatusCardProps,
  ReturnsByDueDateCardProps,
  TypesOfReturnsCardProps,
  YourRoleInReturnsCardProps,
  VatNumberCheckerCardProps,
  TeamAllocationCardProps,
  CalendarCardProps,
  SubmittedReturnsChartCardProps,
  TimeToSubmitCardProps,
  CaptureStatCardProps,
} from './CardProps';

export interface CardRendererProps {
  cardId: CardId;
  props: any; // Union of all card props
}

export const CardRenderer: React.FC<CardRendererProps> = ({ cardId, props }) => {
  switch (cardId) {
    case 'totalEntities':
      return <TotalEntitiesCard {...(props as TotalEntitiesCardProps)} />;
    case 'totalReturns':
      return <TotalReturnsCard {...(props as TotalReturnsCardProps)} />;
    case 'notStarted':
      return <NotStartedCard {...(props as NotStartedCardProps)} />;
    case 'pendingTasks':
      return <PendingTasksCard {...(props as PendingTasksCardProps)} />;
    case 'awaitingReview':
      return <AwaitingReviewCard {...(props as AwaitingReviewCardProps)} />;
    case 'submittedThisMonth':
      return <SubmittedThisMonthCard {...(props as SubmittedThisMonthCardProps)} />;
    case 'tasksByStatus':
      return <TasksByStatusCard {...(props as TasksByStatusCardProps)} />;
    case 'returnsByDueDate':
      return <ReturnsByDueDateCard {...(props as ReturnsByDueDateCardProps)} />;
    case 'typesOfReturns':
      return <TypesOfReturnsCard {...(props as TypesOfReturnsCardProps)} />;
    case 'yourRoleInReturns':
      return <YourRoleInReturnsCard {...(props as YourRoleInReturnsCardProps)} />;
    case 'vatNumberChecker':
      return <VatNumberCheckerCard {...(props as VatNumberCheckerCardProps)} />;
    case 'teamAllocation':
      return <TeamAllocationCard {...(props as TeamAllocationCardProps)} />;
    case 'calendar':
      return <CalendarCard {...(props as CalendarCardProps)} />;
    case 'submittedReturnsChart':
      return <SubmittedReturnsChartCard {...(props as SubmittedReturnsChartCardProps)} />;
    case 'timeToSubmit':
      return <TimeToSubmitCard {...(props as TimeToSubmitCardProps)} />;
    default:
      if (CAPTURE_STAT_CARD_IDS.includes(cardId)) {
        return <CaptureStatCard {...(props as CaptureStatCardProps)} />;
      }
      return null;
  }
};

